export default "__VITE_ASSET__CscitgR1__"